import { attr, fk } from 'redux-orm';
import Model from '../base-model';
import eventReducers from './event.reducer';
import { eventActions } from './event.action';

/**
 * Event
 * @typedef {Object} Event
 * @property {string} id
 * @property {string} title
 * @property {Date} start
 * @property {Date} end
 * @property {string} type
 */

export class Event extends Model {

    static reducer(action, Self, session) {
        switch (action.type) {
        case eventActions.save:
            eventReducers.save(session, action.event);
            break;
        default:
            return undefined;
        }
    }

    toString() {
        return `Event: ${this.title}`
    }
}

Event.modelName = 'Event';

Event.fields = {
    id: attr(),
    title: attr(),
    description: attr(),
    link: attr(),
    start: attr(),
    end: attr(),
    type: attr(),
    video: attr(),
    attachments: attr(),
    chapter: fk('Chapter', 'derayatEvents')
}